import React, { useEffect, useState } from 'react';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import PopUp from '../../../../Shared/Popup/PopUp';

const EntryListPopUp = (props) => {
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (props.selectedEntry) {
      setShowError(false);
    }
  }, [props.selectedEntry]);

  function onBtnClick() {
    if (!props.selectedEntry) {
      setShowError(true);
    }
    else {
      props.onBtnClick();
    }
  }

  return (
    <PopUp showPopUp={props.showPopUp} onClose={() => props.onClose()} className="moving-apartment-entries-popup">
      <h2>שמנו לב שיש בבניין שלך יותר מכניסה אחת</h2>
      <h3>מהי הכניסה שלך?</h3>
      <div className='entry-list'>
        {props.entries.map((item, index) => (
          <div
            key={index}
            onClick={() => {
              props.setSelectedEntry(item);
            }}
            className={`entry ${item.entry == props.selectedEntry?.entry ? 'active' : ''}`}>
            כניסה {item.entry}
          </div>
        ))}
      </div>
      {showError && <p className='entry-error'>אנא בחר כניסה</p>}
      <BtnSubmit
        text={"זאת הכניסה שלי"}
        onclick={onBtnClick}
        formid='moving-block-entry-list-popup'
      />
    </PopUp>
  );
};

export default EntryListPopUp;
